import { Box, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { FC, ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  input: {
    display: 'none',
  },
}));

const id = 'events_documents_upload';

type EventsDocumentsUploadProps = {
  onUpload: (file: File) => void;
};

export const EventsDocumentsUpload: FC<EventsDocumentsUploadProps> = ({ onUpload }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) =>
    onUpload(event.target.files?.[0] as File);

  return (
    <Box>
      <input id={id} type="file" onChange={handleChange} className={classes.input} />
      <label htmlFor={id}>
        <Button variant="contained" color="primary" component="span">
          {t('UPLOAD.BROWSE')}
        </Button>
      </label>
    </Box>
  );
};
